import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9854 16890"
    {...props}
  >
    <path
      d="m4692 12844 469-9c27 143 9 2318 9 2698 0 429 71 299-244 614-332-333-243-168-243-975 0-308-18-2193 9-2328zM6927 280l32 32c56 59 107 126 136 188 81 168 60 486 60 667l-9 1354 1137 9c345 0 781-75 1113 219l106 106c290 327 309 708 189 1019-67 177-235 406-451 512-84 41-205 89-289 105-89 16-183 16-271 33 31 156 9 3535 9 3790 0 337-13 622-123 957-385 1180-1182 1759-2322 1985-102 513 284 1389-632 1570 27 136 9 2696 9 2960 0 239 43 232-90 370l-127 127c-152 151-303 303-455 455l-7 7-8 8-8 7-601-601c-56-67-93-123-96-156l12-3177c-921-182-523-1018-632-1570-745-147-1326-390-1850-1065-345-445-499-891-579-1426-18-123-45-4051-7-4241-92-18-207-18-289-37-347-78-615-316-729-631-109-300-89-673 183-988l123-123c2-2 5-4 8-7 329-282 772-208 1119-208l1119-9c-29-146-10-511-10-686 0-283-39-1145 70-1354 22-43 48-82 77-119l118-118c122-96 271-150 430-151 90 0 256 49 343 97 142 79 221 186 277 310 140 308-4 1651 66 2030l1697-9c77-394-86-1704 74-2040 176-368 647-484 954-298 39 23 82 57 124 97zM4078 11292l1697-9c18 101 21 831-1 912-69 263-439 189-848 189-159 0-292-1-451 0-150 1-327 26-391-170-29-89-25-825-6-922zm4151-6777c21 97 26 4005-2 4196-81 555-269 1012-702 1444-787 787-1639 677-2599 677-1009 0-1806 115-2635-713-396-396-585-869-663-1390-57-388 22-3983-23-4205l6624-9zM3537 608c126 126 81 319 81 487 0 292 21 1276-9 1426l-469 8c26-140 9-414 9-568l-2-1119c2-317 269-355 390-234zM685 3170c282-282 588-207 1101-207h6245c501 0 835-94 1136 207 218 218 168 519-71 759-199 198-778 135-1138 135H2255c-382 0-758 12-1137 0-529-16-723-603-433-894zM6298 626c93-94 175-110 290-44 96 55 117 150 117 260 2 248-17 1553 8 1679l-469 8c-36-191-9-722-9-947 0-179-45-849 63-956z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 186.769,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
